// Hooks
import { Fragment } from 'react';

const Sidemenu = (props) => {
  const { list, scrollRefs, activeAnchor } = props;
  const navHeight = 160;

  const scrollToElement = (el) => {
    const distance = window.pageYOffset + el.getBoundingClientRect().top - navHeight;
    window.scrollTo({
      top: distance,
      behavior: 'smooth',
    });
  };

  const handleItemCLick = (id) => {
    const element = scrollRefs[id].current;
    if (element) scrollToElement(element);
  };

  const handleSubItemCLick = (id) => {
    const element = document.querySelector(`#${id}`);
    if (element) scrollToElement(element);
  };

  return (
    <>
      <div className="SideMenu">
        {list.length >= 1 && (
          <ul className="SideMenu-list">
            {list.map((item, itemIndex) => (
              <Fragment key={`item--${itemIndex}`}>
                <li className={`SideMenu-item ${item.modifier || ''} ${activeAnchor === item.id ? ' is-active' : ''}`}>
                  <a className="SideMenu-anchor" onClick={() => handleItemCLick(item.id)}>
                    <span className="SideMenu-label">{item.title}</span>
                  </a>
                </li>
                {item.list &&
                  item.list.map((subItem, subItemIndex) => (
                    <li className="SideMenu-item SideMenu-item--nested" key={`subitem--${itemIndex}-${subItemIndex}`}>
                      <a className="SideMenu-anchor" onClick={() => handleSubItemCLick(subItem.id)}>
                        <span className="SideMenu-bullet">{subItemIndex + 1} — </span>
                        <span className="SideMenu-label">{subItem.title}</span>
                      </a>
                    </li>
                  ))}
              </Fragment>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default Sidemenu;
